import React from "react";

export default function TeacherIcon(props) {
  const { size = 16 } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h3v3c0 .55.45 1 1 1h.5c.25 0 .5-.1.7-.29L13.5 18H20c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H13l-4 4v-4H4V4h16v12zM6 12h8v2H6v-2zm0-3h12v2H6V9zm0-3h12v2H6V6z"
      />
    </svg>
  );
}
